import { render } from "./OneCustomerChat.vue?vue&type=template&id=3b4caaf8&scoped=true"
import script from "./OneCustomerChat.vue?vue&type=script&lang=js"
export * from "./OneCustomerChat.vue?vue&type=script&lang=js"

import "./OneCustomerChat.vue?vue&type=style&index=0&id=3b4caaf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4caaf8"]])

export default __exports__